import { render, staticRenderFns } from "./OrgWantedStatsByType.vue?vue&type=template&id=47c4694b&scoped=true&"
import script from "./OrgWantedStatsByType.vue?vue&type=script&lang=js&"
export * from "./OrgWantedStatsByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4694b",
  null
  
)

export default component.exports